import { createReducer, on } from "@ngrx/store";
import type { Nullable } from "@models";
import { INewChallengeOptionConfiguration } from "../../shared/model/newChallengeoptionConfiguration.model";
import { setNewChallenge } from "./new-challenge.actions";

export interface NewChallengeState {
  newChallenge: Nullable<INewChallengeOptionConfiguration>;
  error: Nullable<string>;
  isLoading: boolean;
}

const initialState: NewChallengeState = {
  newChallenge: null,
  isLoading: false,
  error: null,
};

export const newChallengesReducer = createReducer(
  initialState,

  on(setNewChallenge, (state, { selectedChallenge }) => ({
    ...state,
    isLoading: false,
    newChallenge: selectedChallenge,
  })),
);
